import script from "./ProfileOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileOptions.vue?vue&type=script&setup=true&lang=js"

import "./ProfileOptions.vue?vue&type=style&index=0&id=f5a229d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5a229d8"]])

export default __exports__